import {AssignmentType} from './assignement-type';
import {AbstractDecisionLoaderService} from '../abstract-decision-loader.service';

export abstract class AbstractMarkLoaderService extends AbstractDecisionLoaderService<number> {
    protected constructor(private readonly assignment: AssignmentType) {
        super('assignments/' + assignment)
    }
}
